import { useState } from "react";
import { cases } from "../../const";
import { Text } from "../ui/Text";
import { Divider } from "../ui/Divider";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import { twMerge } from "tailwind-merge";
import { clsx } from "clsx";

function Stages() {
  const [openedCase, setOpenedCase] = useState<number>(0);
  return (
    <div
      id="cases"
      className="sm:px-[30px] px-5 flex flex-col sm:gap-16 gap-8 w-full items-center scroll-m-5"
    >
      <Text type="title">Наши работы</Text>
      <div className="flex flex-col w-full ">
        {cases.map((caseItem, index) => (
          <div key={caseItem.title + index}>
            <div
              onClick={() => setOpenedCase(index)}
              className={`${
                openedCase === index
                  ? `hover:cursor-auto max-h-[400px] sm:max-h-[545px]`
                  : "hover:cursor-pointer max-h-[60px] sm:max-h-[84px] hover:bg-white-transparent/30 "
              } flex flex-col py-3 sm:py-7 overflow-hidden transition-all duration-600 ease-in-out`}
            >
              <div className="w-full flex justify-between gap-2 items-center focus:outline-none">
                <Text type="subtitle">{caseItem.title}</Text>
                <Text
                  type="main"
                  className="text-gray-main w-fit sm:max-w-full max-w-[266px]"
                >
                  {caseItem.shortDescription}
                </Text>
              </div>
              <div className="mt-4 sm:mt-7">
                <div className="flex flex-col ">
                  <PhotoProvider maskOpacity={0.5}>
                    <div className="flex w-full scrollbar-hidden pb-3 sm:pb-5 touch-scroll overflow-x-auto justify-between gap-2">
                      {caseItem.images.map((image, index) => (
                        <div
                          key={image.srcPreview + index}
                          className="flex flex-col gap-2 items-end snap-x snap-mandatory"
                        >
                          <PhotoView key={index} src={image.srcFull}>
                            <img
                              src={image.srcPreview}
                              alt={image.title.split(" ")[0]}
                              loading="lazy"
                              className={twMerge(
                                clsx(
                                  `h-[210px] sm:h-[330px] max-w-fit! ${
                                    caseItem.aspectRatio
                                      ? ` sm:min-w-auto min-w-[320px]`
                                      : "sm:min-w-[330px] min-w-[210px]"
                                  } hover:cursor-pointer`
                                )
                              )}
                            />
                          </PhotoView>
                          <p className="text-[12px] text-gray-main">
                            {image.title}
                          </p>
                        </div>
                      ))}
                    </div>
                  </PhotoProvider>

                  <Text
                    type="main"
                    className="w-full max-w-[850px] h-[190px] sm:h-36"
                  >
                    {caseItem.description}
                  </Text>
                </div>
              </div>
            </div>
            {index < cases.length - 1 && <Divider />}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Stages;